import { unitMapping } from '@sorare/core/src/lib/style';

type Props = {
  size?: keyof typeof unitMapping;
  className?: string;
};

export const Glove = ({ size = 2, className }: Props) => {
  return (
    <svg
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect x="2" y="9" width="5.41667" height="1.25" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.08333 0H5.41666V0.500002H5.41667V3.66667H6.16667V0.500002H7.33333L7.33333 3.29167V5.16667L7.66667 4.91667V4.19182L8.5 2.66666L10 3.41666L8.08333 7.08333L7.33334 7.2807V7.75H2V6H2V2.20833L2.41667 0.500002H4.08333V0ZM3.33334 0.500003H4.08334V3.66667H3.33334V0.500003Z"
        fill="currentColor"
      />
    </svg>
  );
};
